import { BaseText, Headline3, theme } from 'aimo-ui';
import useCurrentLicensePlateFreeTime from 'hooks/useCurrentLicensePlateFreeTime';
import { t } from 'i18next';
import React from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';

const StyledView = styled.View`
  padding: 16px;
  background-color: ${theme.colors.lightBg.red};
  border-radius: ${theme.borderRadius.allSmall};
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const TimeLeft = styled(Headline3)`
  background: ${theme.colors.white};
  padding: 12px;
  border-radius: 12px;
  color: ${theme.colors.boost.green};
`;

const LoyaltyPermitVehicleFreeTimeInfoBox = () => {
  const selectedVehicleWithFreeTime = useCurrentLicensePlateFreeTime();

  return (
    <StyledView>
      <View>
        <Headline3>{t('permit.loyalty.freeParking')}</Headline3>
        <BaseText>
          {selectedVehicleWithFreeTime?.name ||
            selectedVehicleWithFreeTime?.licensePlate.plateText}{' '}
          • {t('permit.loyalty.timeLeftToday')}
        </BaseText>
      </View>
      <TimeLeft>{selectedVehicleWithFreeTime?.freeTime}</TimeLeft>
    </StyledView>
  );
};

export default LoyaltyPermitVehicleFreeTimeInfoBox;
